import * as React from "react";
import { ShowString } from "./ShowString";

/**
 * Display de solo lectura para un integer con `.choices(unit="…")`:
 * "N {unidad}" (singular/plural) o `nullText` ("Sin límite") cuando es null.
 */
type ShowIntegerChoicesProps = {
  label: string;
  value: number | undefined | null;
  unitSingular?: string;
  unitPlural?: string;
  nullText?: string;
};

export const ShowIntegerChoices: React.FC<ShowIntegerChoicesProps> = ({
  label,
  value,
  unitSingular = "",
  unitPlural = "",
  nullText,
}) => {
  let text: string;
  if (value === undefined || value === null) {
    text = nullText ?? "";
  } else {
    const unit = value === 1 ? unitSingular : unitPlural;
    text = unit ? `${value} ${unit}` : `${value}`;
  }
  return <ShowString value={text} label={label} />;
};
